let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("j6vMO")).then(() => parcelRequire('2mD47'));